import React from "react";
import { Row, Col } from "reactstrap";

const IndustryComparison = ({ data }) => {
    if (!data) return null;

    const { sections, styles } = data;

    return (
        <div className="mb-4">
            {sections?.map((section, index) => (
                <div
                    key={index}
                    style={{
                        border: `1px solid ${styles?.borderColor || "#ccc"}`,
                    }}
                >
                    {/* Section Header */}
                    <div
                        style={{
                            backgroundColor: styles?.headerBg || "#2f4a7f",
                            color: styles?.headerText || "#fff",
                            padding: "10px 16px",
                            fontWeight: "700",
                            fontSize: "18px"
                        }}
                    >
                        {section.title}
                    </div>

                    {/* Content */}
                    <Row className="g-0">
                        {/* BI */}
                        <Col md={6} xs={12}>
                            <div
                                style={{
                                    backgroundColor: styles?.biBg || "#eef2f7",
                                    padding: "16px",
                                    height: "100%"
                                }}
                            >
                                <p className="paragraph m-0"><b>BI USE:</b></p>
                                <p className="mb-0 paragraph">{section.bi}</p>
                            </div>
                        </Col>

                        {/* Predictive */}
                        <Col md={6} xs={12}>
                            <div
                                style={{
                                    backgroundColor: styles?.paBg || "#f6e9ec",
                                    padding: "16px",
                                    height: "100%"
                                }}
                            >
                                <p className="paragraph m-0"><b>PREDICTIVE ANALYTICS USE:</b></p>
                                <p className="mb-0 paragraph">{section.pa}</p>
                            </div>
                        </Col>
                    </Row>
                </div>
            ))}
        </div>
    );
};

export default IndustryComparison;